'use client'

import { FormMode } from 'shared/types/forms'
import Button from 'shared/ui/Button'
import { useModal } from 'shared/ui/Modal/useModal'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import ProfileAddressSingleItem from '../components/ProfileAddressSingleItem'
import ModalAddDeliveryAddress from '../submodules/addresses/components/ModalAddDeliveryAddress'
import { CustomerAddress } from '../submodules/addresses/types'

import styles from './ProfileDeliveryAddress.module.scss'

interface ProfileDeliveryAddressProps {
  addresses: CustomerAddress[]
}

const ProfileDeliveryAddress = ({ addresses }: ProfileDeliveryAddressProps) => {
  // Manage add delivery address modal state
  const { isModalOpen, openModal, closeModal } = useModal()

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.title} id='profile_details_delivery_addresses'>Adresy dostaw</div>
        <ModalAddDeliveryAddress
          isOpen={isModalOpen}
          handleOpen={openModal}
          handleClose={closeModal}
          mode={FormMode.create}
          trigger={
            <Button
              id='profile_delivery_new_address_button'
              fullWidth
              size='medium'
              variant='primary'
            >
              Dodaj nowy adres
            </Button>
          }
          isFirstAddressToAdd={!isNotNilOrEmpty(addresses)}
        />
      </div>
      {
        <>
          {isNotNilOrEmpty(addresses) ? (
            <div>
              {addresses.map((address, index) => (
                <ProfileAddressSingleItem
                  type='delivery'
                  id={`profile_delivery_address_${index}`}
                  key={address.id}
                  address={address}
                />
              ))}
            </div>
          ) : (
            <div>Nie dodano jeszcze żadnego adresu</div>
          )}
        </>
      }
    </div>
  )
}

export default ProfileDeliveryAddress
